<template>
  <v-container fluid class="request-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/my/request/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <!-- <v-btn color="primary" class="button-shadow mr-3" @click="makeReimbursementList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Reimburse
              </v-btn> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="requests-table"
              show-select
              v-model="dataSelected"
              item-key="_id"
              sort-desc
              sort-by="requestnum"
              :footer-props="footer"
              :headers="headers"
              :items="requests"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Request?
                    </v-card-title>
                    <v-card-text>
                      {{ deleterequest.requestnum }} 
                      {{ deleterequest.requestname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteRequest(deleterequest)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="employees.length>0 && employees.find(employee=>employee._id == item.employeeid)['employeeimage']!==''" size="40">
                  <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'] : '' }} </span>
              </template>
              <template v-slot:item.requestnum="{ item }">
                <p class="two-line">{{ item.requesttype  }}</p>
                <p class="two-line">{{ item.requestnum  }}</p>
                <p class="two-line">{{ new Date(item.requestdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.requestaddress="{ item }">
                <p class="two-line">{{ item.requestaddress }}</p>
                <p class="two-line">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }} - {{ townships.length>0 ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
              </template>
              <template v-slot:item._id="{ item }">
                <p v-if="item.requesttype=='Benefit Request'" class="two-line">{{ item.requesttotal.toLocaleString('en-SG') }}</p>
                <p v-else class="two-line">{{ item.requestdays.toLocaleString('en-SG') }} days</p>
                <p v-if="item.requesttype=='Leave Request' || item.requesttype=='Flexible Work Request'" class="two-line">{{ item.transactions.map(trans=>formatStdDate(trans.transstartdate)).join(', ') }}</p>
              </template>
              <template v-slot:item.requeststatus="{ item }">
                <v-chip
                  :color="
                    item.requeststatus=='Approve' ? 'successConst white--text' : 
                    item.requeststatus=='Reject' ? 'error white--text' : 
                    item.requeststatus=='Completed' ? 'greyTint white--text' :
                    item.requeststatus=='Cancel' ? 'warning white--text' : 
                    'primaryConst white--text'"
                  small>
                  {{ item.requeststatus }}
                </v-chip>
                <p class="two-line" style="font-size: x-small;">{{ item.requestreason }}</p>
              </template>
              <template v-slot:item.requesttotal="{ item }">
                {{ item.requesttotal!=null ? item.requesttotal.toFixed(2) : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
<!--               <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.requeststatus=='New'" icon color="primary" @click="editRequestStatusDialog(item)">
                  <v-icon>mdi-text-box-edit-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.requeststatus=='New'" icon color="primary" @click="deleteRequestDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template> -->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
      v-model="isEditStatus"
      persistent
      width="400px"
      max-width="400px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Status</span>
        </v-card-title>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                  :items="statuses"
                  v-model="requeststatus.requeststatus"
                  v-bind:error="errorindex == 11"
                  label="Status"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="12">
                <v-text-field
                  v-model="requeststatus.requestreason"
                  v-bind:error="errorindex == 12"
                  :label="requeststatus.requeststatus=='Approve' || requeststatus.requeststatus=='Reject' ? requeststatus.requeststatus + ' Reason' : 'Reason'"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditStatus = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editRequestStatus"
            >
              Save
            </v-btn>
          </v-card-actions>
         
      </v-card>
      </v-dialog>
    </v-row>
    <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../../config"
import { mapState, mapActions } from 'vuex'
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'RequestHrmList',
  data() {
    return {
      config,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      isEditStatus: false,
      error: undefined,
      haserror: false,
      errorindex: undefined,
      itemPerPage: 500,
      deleterequest: {},
      requeststatus: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Request', value: 'requestnum', sortable: false },
        { text: 'Name', value: 'requestname' },
        { text: 'Amount', value: '_id' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Status', value: 'requeststatus', align: 'center', 'width': '10%' },
        { text: 'Actions', value: 'actions', sortable: false, 'width': '15%' },
      ],
      statuses: ["Approve", "Reject"],
      dataSelected: [],
      requests: [],
    }
  },
  computed: {
    ...mapState('MyAccount', ['isReceiving', 'isDeleting']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('Employee', ['employees']),
  },
  async created () {
    this.requests = await this.getMyRequestsRequest();
    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
    if(this.employees.length==0) this.getEmployeesRequest();
  },
  methods: {
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('MyAccount', ["getMyRequestsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    formatStdDate,
    checkError(){
      if(this.dataSelected.length==0) return false;
      if(this.dataSelected.find(item=>item.requeststatus=='New')!=null) return false;
      else if(this.dataSelected.find(item=>item.requeststatus=='Reject')!=null) return false;
      else if(this.dataSelected.find(item=>item.requeststatus=='Completed')!=null) return false;
      return true;
    },
    checkError1(){
      if(!this.requeststatus.requeststatus){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.requeststatus.requestreason){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkRequests(){
      return this.dataSelected.filter(item=>item.requeststatus=='New' || item.requeststatus=='Reject' || item.requeststatus=='Completed').map(item=>item.requestnum.toString()).join(', ');
    },
    editItem(item) {
      this.$router.push({ name: 'RequestEdit', params: item })
    },
    makeReimbursementList(){
      if(!this.checkError()) {
        if(this.dataSelected.length==0) this.dialogMessage='No Requests selected';
        else this.dialogMessage='The following Requests cannot be reimbursed:  ' + this.checkRequests();
        this.dialogAlert=true; 
        return;
      }
      let requests = Object.assign([], this.dataSelected);
      let json = {requests: requests, isRequests: true};
      this.$router.push({ name: 'ReimbursementAdd', params: json });
    },
    printItem(item) {
      let params = Object.assign({}, item);
      params.isFromHrm = true;
      this.$router.push({ name: 'RequestPrint', params: params })
    },
    viewItem(item) {
      let params = Object.assign({}, item);
      params.isFromHrm = true;
      this.$router.push({ name: 'RequestView', params: params })
    },
    async deleteRequest(item) {
      await this.deleteRequestRequest({_id: item._id});  
      this.dialog = false;
    },
    deleteRequestDialog(item) {
      this.dialog = true;
      this.deleterequest = {
        _id: item._id,
        requestnum: item.requestnum,
        requestname: item.requestname,
      }
    },
    editRequestStatusDialog(item) {
      this.requeststatus = {requestid: item._id};
      this.isEditStatus = true;
    },
    async editRequestStatus() {
      if(!this.checkError1()) return;
      this.isEditStatus = false;
      await this.updateRequestStatusRequest(this.requeststatus);
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
